<template>
    <span v-if="count > 0" class="cart-link__num">
        {{ count }}
    </span>
</template>

<script setup>
import { useCart } from '@/frontend/vue/composables/useCart'

const {
    count
} = useCart()

</script>
